import { auth, guest } from "@/ts/router/middlewares";

export default [
  {
    path: "/place/create",
    name: "PlaceCreation",
    beforeEnter: auth,
    component: () => import("@/vue/views/Places/PlaceCreation.vue"),
    meta: {
      title: "Lesiteco - Création d'un lieu"
    }
  },

  {
    path: "/places",
    name: "Places",
    beforeEnter: auth,
    component: () => import("@/vue/views/Places.vue"),
    meta: {
      title: "Lesiteco"
    },
    children: [
      {
        path: "myplaces",
        name: "MyPlaces",
        beforeEnter: auth,
        component: () => import("@/vue/views/Places/MyPlaces.vue"),
        meta: {
          title: "Lesiteco - Mes Lieux"
        }
      },
      {
        path: "all",
        name: "AllPlaces",
        beforeEnter: auth,
        component: () => import("@/vue/views/Places/AllPlaces.vue"),
        meta: {
          title: "Lesiteco - Tous les Lieux"
        }
      }
    ]
  },
  {
    path: "/place/:id",
    beforeEnter: auth,
    component: () => import("@/vue/views/Place.vue"),
    meta: {
      title: "Lesiteco"
    },
    children: [
      {
        path: "",
        name: "PlaceOverview",
        beforeEnter: auth,
        component: () => import("@/vue/views/Place/PlaceOverview.vue"),
        meta: {
          title: "Lesiteco - Lieu"
        }
      },
      {
        path: "calendar",
        name: "Calendar",
        beforeEnter: auth,
        component: () => import("@/vue/views/Place/Calendar.vue"),
        meta: {
          title: "Lesiteco - Calendrier"
        }
      },
      {
        path: "projects",
        name: "Projects",
        beforeEnter: auth,
        component: () => import("@/vue/views/Place/Projects.vue"),
        meta: {
          title: "Lesiteco - Projets"
        }
      },
      {
        path: "notes",
        name: "Notes",
        beforeEnter: auth,
        component: () => import("@/vue/views/Place/Notes.vue"),
        meta: {
          title: "Lesiteco - Notes"
        }
      },
      {
        path: "events",
        name: "Events",
        beforeEnter: auth,
        component: () => import("@/vue/views/Place/Events.vue"),
        meta: {
          title: "Lesiteco - Evénements"
        }
      },
      {
        path: "contact",
        name: "Contact",
        beforeEnter: auth,
        component: () => import("@/vue/views/Place/Contact.vue"),
        meta: {
          title: "Lesiteco - Contact"
        }
      }
    ]
  },
  {
    path: "/place/:id/edit",
    name: "PlaceEdition",
    beforeEnter: auth,
    component: () => import("@/vue/views/Place/PlaceEdition.vue"),
    meta: {
      title: "Lesiteco - Edition du lieu"
    }
  }
];
